import type { LangCode, PlanI18nEditQuery } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { NameOfResourceBeingEdited } from "@/components/features/_components";
import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { ProductExistingPlanI18nFormModelContextProvider } from "./context";
import { useInitialized } from "../../model/usecase/existing/use-init";
import { PlanI18nFormMain } from "../_shared/components/root";
import { planI18nCategoriesAndManagerStore } from "../_shared/store/categories";
import { HeaderUpdateButton } from "./components/header/update-button/update-button";

type Props = {
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
	serverModel: PlanI18nEditQuery;
};

export const PlanI18nEditPresenter = ({ serverModel, activeLangCode, navigator }: Props) => {
	const init = useInitialized({
		serverModel,
	});

	const { categoryManagerStore } = planI18nCategoriesAndManagerStore;

	const { isDirty } = init.viewModel;
	useTransitionBlock(isDirty);

	const planName = init.viewModel.name.value;
	const hotelID = init.viewModel.hotelID;
	const planID = init.viewModel.planID;

	return (
		<ProductExistingPlanI18nFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="プラン編集"
					activeLangCode={activeLangCode}
					navigator={navigator}
					rightChildren={<HeaderUpdateButton />}
				/>
				<FeatureIslandMainWithCategory categoryManagerStore={categoryManagerStore}>
					{/* @todo Layout の共通化が出来るまでは共通化しない */}
					<NameOfResourceBeingEdited resourceName={planName} />

					<PlanI18nFormMain
						planI18nCategoriesAndManagerStore={planI18nCategoriesAndManagerStore}
						hotelID={hotelID}
						planID={planID}
						hotelEmailAddress={init.queryData.hotelEmailAddress}
					/>
				</FeatureIslandMainWithCategory>
			</FeatureIslandContainer>
		</ProductExistingPlanI18nFormModelContextProvider>
	);
};

PlanI18nEditPresenter.displayName = "PlanI18nEditPresenter";
